import clsx from "clsx";

import * as styles from "./Grid.css";

export interface Props extends React.ComponentPropsWithRef<"div"> {}

export default function Grid({ children, className, id, ...props }: Props) {
  return (
    <div className={clsx(styles.grid, className)} {...props} id={id}>
      {children}
    </div>
  );
}
